export const APP_ENV = 'production';
export const APP_DEBUG = true;
export const APP_URL = 'https://drivingcalendar.com';
export const API_URL = 'https://api.drivingcalendar.com';
export const CLIENT_ID = 2;
export const CLIENT_SECRET = 'cpwupGtc9WDv8Jw4kNDZnwLOoSBxJM8nHENZ68QT';
